/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cashbackofferuntil2Inputs */

const en_cashbackofferuntil2 = /** @type {(inputs: Cashbackofferuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offer ends ${i?.date}`)
};

const de_cashbackofferuntil2 = /** @type {(inputs: Cashbackofferuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktion bis ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Offer ends {date}" |
*
* @param {Cashbackofferuntil2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cashbackofferuntil2 = /** @type {((inputs: Cashbackofferuntil2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashbackofferuntil2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cashbackofferuntil2(inputs)
	return de_cashbackofferuntil2(inputs)
});
export { cashbackofferuntil2 as "cashbackOfferUntil" }